import { useState } from 'react';

export default function Testimonial() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [timeSaved, setTimeSaved] = useState(60);

  const testimonials = [
    {
      quote: "Hemos reducido nuestra reunión de camas de una hora a 15 minutos. El equipo se siente menos estresado porque la información ya está consolidada cuando llegamos.",
      name: "Hospital Universitario Regional",
      role: "Supervisora de Enfermería",
      details: "320 camas · 3 semanas",
      metric: "85% reducción en tiempo",
      icon: "ri-nurse-line",
      color: "#06B6D4"
    },
    {
      quote: "Antes recibíamos 100 llamadas al día preguntando por camas disponibles. Ahora el equipo consulta el mapa en tiempo real y las llamadas se redujeron a menos de 30.",
      name: "Centro Médico Provincial",
      role: "Jefe de Admisiones",
      details: "180 camas · 4 semanas",
      metric: "70% menos llamadas",
      icon: "ri-phone-line",
      color: "#8B5CF6"
    },
    {
      quote: "La trazabilidad completa nos ha permitido identificar cuellos de botella que no veíamos. Ahora sabemos exactamente cuánto tarda cada proceso.",
      name: "Hospital General Metropolitano",
      role: "Director de Operaciones",
      details: "450 camas · 2 meses",
      metric: "4h diarias ahorradas",
      icon: "ri-bar-chart-line",
      color: "#10B981"
    },
    {
      quote: "Recibimos las notificaciones directamente en nuestros móviles y confirmamos desde ahí. No hay que estar llamando ni buscando a nadie.",
      name: "Complejo Hospitalario del Sur",
      role: "Coordinadora de Limpieza",
      details: "280 camas · 3 semanas",
      metric: "Confirmación en 2 min",
      icon: "ri-checkbox-circle-line",
      color: "#F59E0B"
    }
  ];

  const calculateSavedTime = (minutes: number) => {
    // Tiempo objetivo con PreBedAI es 15 minutos
    const targetTime = 15;
    const saved = Math.max(0, minutes - targetTime);
    const percentage = minutes > targetTime ? Math.round((saved / minutes) * 100) : 0;
    return { saved, percentage };
  };

  const { saved, percentage } = calculateSavedTime(timeSaved);

  return (
    <section className="py-16 sm:py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 dots-pattern"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        {/* Interactive Time-Saving Bar */}
        <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 border-2 border-primary-400 shadow-xl mb-10 sm:mb-16 relative overflow-hidden">
          {/* Subtle gradient background */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 to-transparent pointer-events-none"></div>
          
          <div className="relative z-10">
            <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
              Ahorro de Tiempo
            </h4>
          
          <div className="max-w-2xl mx-auto">
            <div className="mb-4 sm:mb-6">
              <div className="flex justify-between items-center mb-2 sm:mb-3">
                <span className="text-gray-700 text-sm sm:text-base font-medium">Duración actual de tu reunión:</span>
                <span className="text-xl sm:text-2xl font-bold text-gray-900">{timeSaved} min</span>
              </div>
              
              <input
                type="range"
                min="15"
                max="90"
                value={timeSaved}
                onChange={(e) => setTimeSaved(Number(e.target.value))}
                className="w-full h-2 sm:h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                style={{
                  background: `linear-gradient(to right, #10B981 0%, #10B981 ${((timeSaved - 15) / 75) * 100}%, #e5e7eb ${((timeSaved - 15) / 75) * 100}%, #e5e7eb 100%)`
                }}
              />
              
              <div className="flex justify-between text-xs text-gray-500 mt-1 sm:mt-2">
                <span>15 min</span>
                <span>90 min</span>
              </div>
            </div>

            {timeSaved > 15 && (
              <div className="bg-white rounded-xl p-4 sm:p-6 shadow-xl border-2 border-green-400">
                <div className="text-center">
                  <p className="text-gray-600 mb-1 sm:mb-2 text-sm font-medium">Con PreBedAI podrías ahorrar:</p>
                  <p className="text-3xl sm:text-4xl font-bold text-green-600 mb-1 sm:mb-2">
                    {saved} minutos
                  </p>
                  <p className="text-base sm:text-xl text-gray-700 font-semibold mb-3 sm:mb-4">
                    por reunión ({percentage}% de reducción)
                  </p>
                  <div className="grid grid-cols-3 gap-2 sm:gap-4 mt-4 sm:mt-6">
                    <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-2 sm:p-3 shadow-sm border border-green-200">
                      <p className="text-lg sm:text-2xl font-bold text-green-700">{saved * 5}</p>
                      <p className="text-xs text-green-600 font-medium">min/semana</p>
                    </div>
                    <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-lg p-2 sm:p-3 shadow-sm border border-cyan-200">
                      <p className="text-lg sm:text-2xl font-bold text-cyan-700">{Math.round((saved * 5 * 52) / 60)}</p>
                      <p className="text-xs text-cyan-600 font-medium">horas/año</p>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-2 sm:p-3 shadow-sm border border-purple-200">
                      <p className="text-lg sm:text-2xl font-bold text-purple-700">{Math.round((saved * 5 * 52) / 60 / 8)}</p>
                      <p className="text-xs text-purple-600 font-medium">días/año</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}
